type AnswerTextPreviewProps = {
  text?: string | null;
};

export default function AnswerTextPreview({ text }: AnswerTextPreviewProps) {
  return <span className="truncate text-base text-wrap">{text}</span>;
}
